import classes from './ScheduleLabel.module.scss';
const ScheduleLabel = (schedule) => <div className={classes.scheduleLabel}>
  <span>{schedule.label}</span>
  <span>{schedule.startTime}-{schedule.endTime}</span>
</div>

export default ScheduleLabel;